// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CaseAllowedCaseStatusModel {
    static getAttributeTypeMap() {
        return CaseAllowedCaseStatusModel.attributeTypeMap;
    }
}
CaseAllowedCaseStatusModel.discriminator = undefined;
CaseAllowedCaseStatusModel.additionalProperties = false;
CaseAllowedCaseStatusModel.attributeTypeMap = [
    {
        "name": "caseStatusId",
        "baseName": "caseStatusId",
        "type": "number"
    },
    {
        "name": "caseStatusCode",
        "baseName": "caseStatusCode",
        "type": "string"
    },
    {
        "name": "caseStatusDescription",
        "baseName": "caseStatusDescription",
        "type": "string"
    },
    {
        "name": "systemStatus",
        "baseName": "systemStatus",
        "type": "SystemStatus"
    },
    {
        "name": "isInitial",
        "baseName": "isInitial",
        "type": "boolean"
    },
    {
        "name": "isFinal",
        "baseName": "isFinal",
        "type": "boolean"
    },
    {
        "name": "caseSubStatusId",
        "baseName": "caseSubStatusId",
        "type": "number"
    },
    {
        "name": "caseSubStatusCode",
        "baseName": "caseSubStatusCode",
        "type": "string"
    },
    {
        "name": "caseSubStatusDescription",
        "baseName": "caseSubStatusDescription",
        "type": "string"
    },
    {
        "name": "nextCaseTypes",
        "baseName": "nextCaseTypes",
        "type": ""
    },
    {
        "name": "isHidden",
        "baseName": "isHidden",
        "type": "boolean"
    },
];
//# sourceMappingURL=caseAllowedCaseStatusModel.js.map